import { PostalCodeAndCityInputShadcn } from "@/dentlab/src/components/postal-code-and-city-input/postal-code-and-city-input.component";
import { CountrySelectShadcn } from "@/dentlab/src/forms/form-input-components/selects/country-select/country.select";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { CountryEnum } from "@/lib/supabase/supabaseEnums";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { getLabCountry } from "@/dentlab/src/lib/utils/country-utils";
import { InputWrapper } from "@/dentlab/src/components/input-wrapper";

export const JobPatientCityPostalCodeCountry: React.FC<{
	disabled: boolean;
	inputHeight?: number;
	validationError?: string | null;
}> = ({ disabled, inputHeight, validationError }) => {
	const { formFieldsPatient, setPatientField } = useJobStore((state) => ({
		formFieldsPatient: state.formFieldsPatient,
		setPatientField: state.setPatientField,
	}));
	const labCountry = useCentralStore((state) => getLabCountry(state.organization));
	const country = formFieldsPatient.country || labCountry;
	return (
		<InputWrapper validationError={validationError}>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					gap: "8px",
				}}
			>
				<div className="w-[50%]">
					<CountrySelectShadcn
						onChange={(value) => setPatientField("country", value)}
						value={country}
						disabled={disabled}
						inputHeight={inputHeight}
						invalid={!!validationError}
					/>
				</div>
				<div className="w-[50%]">
					<PostalCodeAndCityInputShadcn
						country={country as CountryEnum}
						postalCodeValue={formFieldsPatient.postal_code ?? ""}
						cityValue={formFieldsPatient.city ?? ""}
						onPostalCodeChange={(value) =>
							setPatientField("postal_code", value)
						}
						onCityChange={(value) => setPatientField("city", value)}
						required={false}
						disabled={disabled}
						inputHeight={inputHeight}
						invalid={!!validationError}
					/>
				</div>
			</div>
		</InputWrapper>
	);
};
